import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';
import { Line } from 'react-chartjs-2';

// Chart.js bileşenlerini kayıt ediyoruz
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const CampaignTimeSeriesChart = ({ data }) => {
  // Veri yoksa boş bir grafik göster
  if (!data || !data.daily_trends || data.daily_trends.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center bg-gray-50 rounded-lg">
        <p className="text-gray-500">Gösterilecek veri yok</p>
      </div>
    );
  }

  // Tarihleri ters çevir (en yeni tarihler başta olsun)
  const sortedTrends = [...data.daily_trends].reverse();

  // Grafik verilerini hazırla
  const chartData = {
    labels: sortedTrends.map(trend => {
      // Tarihi daha okunabilir formata çevir
      const date = new Date(trend.date);
      return date.toLocaleDateString('tr-TR', { 
        day: 'numeric', 
        month: 'short' 
      });
    }),
    datasets: [
      {
        label: 'Kullanım Sayısı',
        data: sortedTrends.map(trend => trend.usage_count || 0),
        borderColor: 'rgb(59, 130, 246)',
        backgroundColor: 'rgba(59, 130, 246, 0.1)',
        borderWidth: 2,
        pointRadius: 4,
        pointBackgroundColor: 'rgb(59, 130, 246)',
        fill: true,
        tension: 0.3
      },
      {
        label: 'İndirim Tutarı (₺)',
        data: sortedTrends.map(trend => trend.discount_given || 0),
        borderColor: 'rgb(16, 185, 129)',
        backgroundColor: 'rgba(16, 185, 129, 0.1)',
        borderWidth: 2,
        pointRadius: 4,
        pointBackgroundColor: 'rgb(16, 185, 129)',
        fill: true,
        tension: 0.3,
        yAxisID: 'y1'
      }
    ]
  };

  // Grafik seçenekleri
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          font: {
            size: 12
          }
        }
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        callbacks: {
          label: function(context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.datasetIndex === 0) {
              label += new Intl.NumberFormat('tr-TR').format(context.parsed.y);
            } else {
              label += '₺' + new Intl.NumberFormat('tr-TR', { 
                minimumFractionDigits: 2, 
                maximumFractionDigits: 2 
              }).format(context.parsed.y);
            }
            return label;
          }
        }
      }
    },
    scales: {
      x: {
        grid: {
          display: false
        },
        ticks: {
          font: {
            size: 11
          }
        }
      },
      y: {
        type: 'linear',
        display: true,
        position: 'left',
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        },
        ticks: {
          font: {
            size: 11
          },
          callback: function(value) {
            return new Intl.NumberFormat('tr-TR').format(value);
          }
        }
      },
      y1: {
        type: 'linear',
        display: true,
        position: 'right',
        grid: {
          drawOnChartArea: false,
        },
        ticks: {
          font: {
            size: 11
          },
          callback: function(value) {
            return '₺' + new Intl.NumberFormat('tr-TR', { 
              minimumFractionDigits: 0, 
              maximumFractionDigits: 0 
            }).format(value);
          }
        }
      }
    },
    interaction: {
      mode: 'nearest',
      axis: 'x',
      intersect: false
    }
  };

  return (
    <div className="h-64">
      <Line data={chartData} options={options} />
    </div>
  );
};

export default CampaignTimeSeriesChart;